import React from 'react';
import explanationImage from '../../assets/notifications.png';
import icons from '../../IconLoader';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';

/**
 * Two-stage notification flow for business updates:
 *   1. Subscribe panel — toggle on/off
 *   2. Explanation — shown after subscribing, links to Telegram bot.
 *
 * The two stages share the same trigger but are visually distinct, so we
 * surface them via two separate `Modal` instances.
 */
export function BusinessNotificationModal({
    isOpen,
    onClose,
    isGuest,
    subscribed,
    onToggleSubscribed,
}) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="sm" title="התראות עדכונים">
            {isGuest ? (
                <div className="text-center space-y-4">
                    <p className="text-ink-muted">שירות זה זמין רק למשתמשים מחוברים.</p>
                    <Button variant="subtle" fullWidth onClick={onClose}>סגור</Button>
                </div>
            ) : (
                <div className="text-center space-y-5">
                    <p className="text-ink">האם ברצונכם לקבל עדכונים?</p>
                    <button
                        type="button"
                        role="switch"
                        aria-checked={subscribed}
                        onClick={onToggleSubscribed}
                        className={`relative w-16 h-8 mx-auto rounded-pill transition-colors duration-300 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-400 ${
                            subscribed ? 'bg-brand-500' : 'bg-line-strong'
                        }`}
                    >
                        <span
                            className={`absolute top-0.5 left-0.5 w-7 h-7 bg-white rounded-pill shadow-sm transform transition-transform duration-300 ${
                                subscribed ? 'translate-x-8' : ''
                            }`}
                        />
                    </button>
                    <p className="text-sm text-ink-muted">לחצו כדי להפעיל / לבטל</p>
                </div>
            )}
        </Modal>
    );
}

export function BusinessNotificationExplanationModal({
    isOpen,
    onClose,
    businessId,
    chatId,
}) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="sm" title="קבלת התראות">
            <div className="text-center space-y-4">
                <img src={explanationImage} alt="הסבר על התראות" className="w-full rounded-xl" />
                <p className="text-ink-muted text-sm">
                    כעת תקבלו עדכונים באמצעות אייקון הפעמון שבתפריט העליון.
                </p>
                <Button
                    variant="primary"
                    fullWidth
                    onClick={() => {
                        window.open(`https://t.me/MekomitBot?start=s_${businessId}_${chatId}`, '_blank');
                        onClose();
                    }}
                    icon={<img src={icons.telegram} alt="" aria-hidden="true" className="w-5 h-5" />}
                    iconPosition="end"
                >
                    קבלת עדכונים בטלגרם
                </Button>
            </div>
        </Modal>
    );
}
